import { DomainError } from '../errors/domain-error';

export const CREATOR_COMMUNITY_MAX = 10;

export function assertCreatorCommunityLimit(currentCount: number): void {
  if (currentCount >= CREATOR_COMMUNITY_MAX) {
    throw new DomainError(`Creators can manage up to ${CREATOR_COMMUNITY_MAX} communities`);
  }
}
